<template>
    <form class="max-w-4xl">
        <div class="grid grid-cols-1 gap-x-8 gap-y-6" v-if="dancer">
            <form-field-text
                id="dancer-name"
                label="Name"
                field="dancer_name"
                :value="dancer.dancer_name"
                @update="updateDancerField"
            ></form-field-text>
            <form-field-text
                id="dancer-slug"
                label="Slug"
                field="dancer_slug"
                :value="dancer.dancer_slug"
                @update="updateDancerField"
            ></form-field-text>
            <form-field-text
                id="dancer-website"
                label="Website"
                field="dancer_website"
                :value="dancer.dancer_website"
                @update="updateDancerField"
            ></form-field-text>
            <form-field-text
                id="dancer-instagram"
                label="Instagram"
                field="dancer_instagram"
                :value="dancer.dancer_instagram"
                @update="updateDancerField"
            ></form-field-text>
            <form-field-text
                id="dancer-tiktok"
                label="TikTok"
                field="dancer_tiktok"
                :value="dancer.dancer_tiktok"
                @update="updateDancerField"
            ></form-field-text>
            <form-field-text
                id="dancer-youtube"
                label="YouTube"
                field="dancer_youtube"
                :value="dancer.dancer_youtube"
                @update="updateDancerField"
            ></form-field-text>
        </div>
        <div class="mt-10">
            <alert-error class="-mt-4 mb-5" :alert="error" :onDismiss="clearError"></alert-error>
            <div class="flex flex-row">
                <button-primary buttonText="Save" :buttonDisabled="disabled" :buttonClick="putDancer"></button-primary>
            </div>
        </div>
    </form>
</template>

<script>
import {mapState, mapActions} from 'pinia';

export default {
    name: 'FormDancerEdit',
    computed: {
        ...mapState(useStoreDancer, {
            dancer: 'dancer',
            disabled: 'disabled',
            error: 'error',
        }),
    },
    methods: {
        ...mapActions(useStoreDancer, {
            updateDancerField: 'updateDancerField',
            putDancer: 'putDancer',
            clearError: 'clearError',
        }),
    },
};
</script>
